import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["theme"];
import React from 'react';
import PropTypes from 'prop-types';
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "b",
  cx: "20",
  cy: "20",
  r: "20"
}), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "175%",
  height: "175%",
  x: "-37.5%",
  y: "-22.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  "in": "SourceAlpha",
  radius: "2",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "6",
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: "6"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0.6 0 0 0 0 0.4 0 0 0 0 1 0 0 0 0.6 0"
})));
var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  strokeWidth: "2",
  d: "M28 13a6.744 6.744 0 0 0-4.738 1.926 6.505 6.505 0 0 0-1.808 3.375C18.92 18.785 17 20.961 17 23.588 17 26.568 19.47 29 22.5 29h11.717C36.855 29 39 26.889 39 24.294c0-2.449-1.917-4.442-4.35-4.662.012-1.703-.603-3.41-1.92-4.706A6.73 6.73 0 0 0 28 13z"
});
var UploadIcon = function UploadIcon(_ref) {
  var theme = _ref.theme,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "56",
    height: "56",
    viewBox: "0 0 56 56"
  }, props), _ref2, /*#__PURE__*/React.createElement("g", {
    fill: theme && theme.upload && theme.upload.icons && theme.upload.icons.main ? theme.upload.icons.main.fill : '#9000FF',
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 2)"
  }, _ref3, /*#__PURE__*/React.createElement("use", {
    fill: theme && theme.upload && theme.upload.icons && theme.upload.icons.main ? theme.upload.icons.main.fill : '#9000FF',
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: theme && theme.upload && theme.upload.icons && theme.upload.icons.main ? theme.upload.icons.main.stroke : '#FFF'
  }, _ref4, /*#__PURE__*/React.createElement("path", {
    fill: theme && theme.upload && theme.upload.icons && theme.upload.icons.main ? theme.upload.icons.main.stroke : '#FFF',
    fillRule: "nonzero",
    strokeWidth: ".3",
    d: "M28.348 19a.648.648 0 0 0-.486.184l-2.63 2.353a.704.704 0 0 0-.045 1c.253.272.738.292 1.016.044l1.427-1.28v3.523c0 .39.322.705.718.705a.712.712 0 0 0 .717-.705V21.3l1.428 1.28c.278.248.748.214 1.016-.044.282-.273.23-.75-.045-1l-2.63-2.353c-.143-.128-.247-.184-.486-.184z"
  }))));
};
process.env.NODE_ENV !== "production" ? UploadIcon.propTypes = {
  stroke: PropTypes.string
} : void 0;
export default UploadIcon;